import "./browser/main";
import registerServiceWorker from "./registerServiceWorker";

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js